import React from 'react';
import { ReactComponent as AddIcon } from 'icons/plus-filled-icon.svg';
import { ReactComponent as DeleteIcon } from 'icons/x-icon.svg';
import clsx from 'clsx';
import { setCurrency } from 'utils/functionality';
import { useState } from 'react';
// import { useAppContext } from 'components/Context/AppContext';
import ReactDOM from 'react-dom';
import AddViolationModal from 'components/Modals/AddViolation';

const InputViolation = ({
  isOnEdit = true,
  setViolationList,
  violationList,
  totalPrice,
  violationPrice,
  data,
  onConfirm,
  onDelete,
}) => {
  const [showAddViolationModal, setShowAddViolationModal] = useState(false);

  const deleteHandler = (id) => {
    if (onDelete) {
      onDelete(id);
      return;
    }
    setViolationList((prev) => prev.filter((item) => item.id !== id));
  };

  const addHandler = () => {
    setShowAddViolationModal(true);
  };

  return (
    <>
      <div className="input-violation">
        <div className="input-violation__header">
          <label className="input-violation__header-title">Jenis Pelanggaran</label>
          {isOnEdit ? (
            <div className="input-violation__header-add" onClick={addHandler}>
              <AddIcon className="input-violation__add-icon" />
              <p>Tambah Denda</p>
            </div>
          ) : null}
        </div>
        <div className="input-violation__body">
          {data.length > 0 || violationList.length > 0 ? (
            <>
              {data.map((item, idx) => (
                <div key={idx} className={clsx('input-violation__body-item', isOnEdit && 'input-violation__edit')}>
                  <p>{item.violation}</p>
                  <div className={'input-violation__item-price'}>
                    <p>{setCurrency(item.cost)}</p>
                    {isOnEdit ? (
                      <DeleteIcon className="input-violation__delete-icon" onClick={() => deleteHandler(item.id)} />
                    ) : null}
                  </div>
                </div>
              ))}
              {violationList.map((item, idx) => (
                <div key={idx} className={clsx('input-violation__body-item', isOnEdit && 'input-violation__edit')}>
                  <p>{item.violation}</p>
                  <div className={'input-violation__item-price'}>
                    <p>{setCurrency(item.cost)}</p>
                    {isOnEdit ? (
                      <DeleteIcon className="input-violation__delete-icon" onClick={() => deleteHandler(item.id)} />
                    ) : null}
                  </div>
                </div>
              ))}
              <div className="input-violation__body-item-total">
                <p>Total</p>
                <div className="input-violation__item-price">
                  <p>{setCurrency(totalPrice + violationPrice)}</p>
                </div>
              </div>
            </>
          ) : (
            <div className={clsx('input-violation__body-item input-violation__item-empty')}>
              <p>Tidak ada denda</p>
            </div>
          )}
        </div>
      </div>
      {showAddViolationModal &&
        ReactDOM.createPortal(
          <AddViolationModal
            setShowAddViolationModal={setShowAddViolationModal}
            setViolationList={setViolationList}
            onConfirm={onConfirm}
          />,
          document.getElementById('modal'),
        )}
    </>
  );
};

export default InputViolation;
